var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#585858"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 5.0013L11.8569 4.9H11.7556H10.2444H10.1431L10.1445 5.0013L10.2556 13.5594L10.2568 13.6581H10.3556H11.6444H11.7432L11.7444 13.5594L11.8555 5.0013ZM11.5532 16.9452L11.5538 16.9448C11.7195 16.839 11.8511 16.6991 11.948 16.5263C12.0495 16.3518 12.1 16.1602 12.1 15.9535C12.1 15.6412 11.9921 15.3703 11.7779 15.146C11.5635 14.9217 11.3025 14.807 11 14.807C10.6975 14.807 10.4365 14.9217 10.2221 15.146C10.0079 15.3703 9.9 15.6412 9.9 15.9535C9.9 16.2658 10.0079 16.5367 10.2221 16.7609C10.4365 16.9853 10.6975 17.1 11 17.1C11.2028 17.1 11.3881 17.0488 11.5532 16.9452Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote2Icon);
export default __webpack_public_path__ + "static/media/note2Icon.4bb89ceb51c0d01f9891ce3b97de07c5.svg";
export { ForwardRef as ReactComponent };